import { render, staticRenderFns } from "./step0.vue?vue&type=template&id=1c0d9c5c&scoped=true"
import script from "./step0.vue?vue&type=script&lang=js"
export * from "./step0.vue?vue&type=script&lang=js"
import style0 from "./step0.vue?vue&type=style&index=0&id=1c0d9c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d9c5c",
  null
  
)

export default component.exports